var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAskHelp = function SvgAskHelp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ask_help_a",
    x1: "0%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00B1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00C8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ask_help_b",
    x1: "0%",
    x2: "101.131%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FB0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#ask_help_a)",
    d: "M7.138 61h34.469c2.725 0 4.592-2.114 4.038-4.412-2.28-9.453-11.393-16.556-21.513-16.556-10.017 0-18.726 6.995-21.032 16.556C2.546 58.886 4.413 61 7.138 61zm10.67-23.135a13.293 13.293 0 0 1-6.734-11.567C11.074 18.954 17.028 13 24.372 13c3.533 0 6.743 1.377 9.124 3.624l-2.058 2.182A10.25 10.25 0 0 0 24.372 16c-5.687 0-10.298 4.61-10.298 10.298 0 5.687 4.61 10.298 10.298 10.298 5.152 0 9.494-3.809 10.199-8.859l2.971.415a13.308 13.308 0 0 1-6.745 9.792c8.633 2.395 15.676 9.282 17.764 17.94 1.03 4.27-2.366 8.116-6.954 8.116H7.137C2.55 64-.845 60.154.184 55.885c2.127-8.82 9.022-15.712 17.624-18.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ask_help_b)",
    d: "M61 22V5H34v17a3 3 0 0 1 3 3v1.686l4.923-4.012A3 3 0 0 1 43.818 22H61zm-27 6.79V25h-1a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h29a2 2 0 0 1 2 2v19a2 2 0 0 1-2 2H43.818l-6.555 5.341A2 2 0 0 1 34 28.791zM41.5 15a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm6 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm6 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"
  }))));
};
export default SvgAskHelp;